import React, { useState } from 'react';

// Reusable password input with an eye toggle to show/hide the value.
// Forwards every prop to the underlying <input> (className, value, onChange,
// required, minLength, autoComplete, placeholder, disabled, id, name, style…).
// Uses the caller's className if provided, otherwise falls back to form-control.
const PasswordInput = ({ className = 'form-control', style, ...rest }) => {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: 'relative' }}>
      <input
        type={show ? 'text' : 'password'}
        className={className}
        style={{ ...style, paddingRight: '40px' }}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShow(s => !s)}
        title={show ? 'Hide password' : 'Show password'}
        aria-label={show ? 'Hide password' : 'Show password'}
        style={{
          position: 'absolute', right: '0', top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px',
          color: 'var(--text-secondary)', padding: '4px', lineHeight: 1,
          // 44px touch target (mobile-accessibility) — the visual glyph stays
          // 16px but the hit area covers the input's right edge.
          minWidth: '44px', minHeight: '44px',
        }}
      >
        <i className={`fas ${show ? 'fa-eye-slash' : 'fa-eye'}`}></i>
      </button>
    </div>
  );
};

export default PasswordInput;